/** Listras rubro-negras no topo e blobs desfocados atrás de todo o conteúdo. */
export function Background({ extraBlob = false }: { extraBlob?: boolean }) {
  return (
    <div className="bg-layer" aria-hidden>
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      {extraBlob ? <div className="blob blob-3" /> : null}
      <div className="bg-stripes" />
    </div>
  );
}
